export default class AdminDocenteForm {

    /**
     *
     * @param {string} data.empresaId
     * @param {string} data.empresaNombre
     */
    constructor(data){
        this.empresaId = data.empresaId;
        this.empresaNombre = data.empresaNombre;
    }

    /**
     *
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: 'Nuevo docente - ' + myself.empresaNombre,
            method: 'POST',
            url: '/api/admin/docentes'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        let data = {
            nombre: '', url: ''
        };
        this.modal.render(this.render(data));
    }

    /**
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(id, options) {
        let myself = this;
        let modalOpts = {
            title: 'Editar docente - ' + myself.empresaNombre,
            method: 'PUT',
            url: `/api/admin/docentes/${id}`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/docentes/${id}`, {
            then: function (response) {
                myself.modal.render(myself.render(response.data));
            }
        });
    }

    render(data) {
        let items = [
            {name: 'nombres', type: 'text', text: 'Nombres', attr: ' required maxlenght="250"'},
            {name: 'ap_paterno', type: 'text', text: 'Ap. Paterno', attr: ' required maxlenght="250"'},
            {name: 'ap_materno', type: 'text', text: 'Ap. Materno', attr: 'maxlenght="250"'},
            {name: 'correo', type: 'email', text: 'Correo', attr: 'required maxlenght="200"'},
        ];
        let html = '';
        items.forEach(item => {
            let value = (data[item.name]) ? data[item.name] : '';
            html += `<div class="row form-group my-1">
            <label for="${item.name}" class="col-form-label col col-md-4">${item.text}</label>
            <div class="col col-md-8">
                <input type="${item.type}" value="${value}" id="${item.name}" name="${item.name}" class="form-control form-control-sm" ${item.attr}/>
            </div>
        </div>`;
        });
        return `<form>
        <input type="hidden" name="empresa_id" value="${this.empresaId}"/>
        ${html}
        </form>`;
    }
}
